import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const UserAuthContext = createContext(null);

export const UserAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = sessionStorage.getItem('user_token');
    if (token) {
      axios.get(`${API_URL}/api/user/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => setUser(res.data))
        .catch(() => {
          sessionStorage.removeItem('user_token');
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${API_URL}/api/user/login`, { email, password });
    sessionStorage.setItem('user_token', res.data.token);
    // Also store the admin token so AuthContext picks it up — this user has unified admin access
    if (res.data.admin_token) {
      sessionStorage.setItem('admin_token', res.data.admin_token);
    }
    setUser({ email: res.data.email, name: res.data.name });
    return res.data;
  };

  const logout = () => {
    sessionStorage.removeItem('user_token');
    sessionStorage.removeItem('admin_token');
    setUser(null);
  };

  const isAuthenticated = !!user;

  return (
    <UserAuthContext.Provider value={{ user, login, logout, isAuthenticated, loading }}>
      {children}
    </UserAuthContext.Provider>
  );
};

export const useUserAuth = () => {
  const ctx = useContext(UserAuthContext);
  if (!ctx) throw new Error('useUserAuth must be inside UserAuthProvider');
  return ctx;
};
